import axios from 'axios'
import _difference from 'lodash/difference'

import { getProductBundleReasonsByProductBundleId } from '../selectors/product-bundle-reasons'
import { handleRequestError } from './request'

export const REQUEST_PRODUCT_BUNDLE_REASONS = 'REQUEST_PRODUCT_BUNDLE_REASONS'
export const RECEIVE_PRODUCT_BUNDLE_REASONS = 'RECEIVE_PRODUCT_BUNDLE_REASONS'
export const REMOVE_PRODUCT_BUNDLE_REASON = 'REMOVE_PRODUCT_BUNDLE_REASON'

export const requestProductBundleReasons =
    ({ productBundleId }) =>
    (dispatch) => {
        dispatch({ type: REQUEST_PRODUCT_BUNDLE_REASONS })

        return axios
            .get(`/productbundle/${productBundleId}/reasons`, { headers: { 'Cache-Control': 'no-cache' } })
            .then((response) => {
                const responseData = response?.data || []
                dispatch(receiveProductBundleReasons({ items: responseData, fetchSuccessful: true }))
                return responseData
            })
            .catch((error) => {
                if (error?.response?.status === 404) {
                    dispatch(receiveProductBundleReasons({ items: [], fetchSuccessful: true }))
                    return Promise.resolve()
                }
                dispatch(handleRequestError(error))
                return Promise.reject(error)
            })
    }

export const saveProductBundleReasons =
    ({ productBundleId, reasonTypes: newReasonTypes }) =>
    (dispatch, getState) => {
        const existingReasons = getProductBundleReasonsByProductBundleId(getState(), { productBundleId })
        const existingReasonTypes = existingReasons.map(({ type }) => type)

        // Find creatable types
        const creatableReasonTypes = newReasonTypes.filter(
            (newReasonType) => !existingReasonTypes.includes(newReasonType)
        )
        const creatableReasonsPromises = creatableReasonTypes.map((type) => {
            const creatableReasonData = { productBundleId, type }
            return dispatch(createProductBundleReason(creatableReasonData))
        })

        // Find deletable ids
        const deletableReasonTypes = _difference(existingReasonTypes, newReasonTypes)
        const deletableReasonIds = existingReasons
            .filter((reason) => deletableReasonTypes.includes(reason.type))
            .map(({ id }) => id)
        const deletableReasonPromises = deletableReasonIds.map((id) => dispatch(deleteProductBundleReason({ id })))

        return Promise.all([...creatableReasonsPromises, ...deletableReasonPromises])
    }

const createProductBundleReason =
    ({ productBundleId, type }) =>
    (dispatch) =>
        axios
            .post(`/productbundlereason`, { productBundleId, type })
            .then((response) => {
                const responseData = response?.data
                if (responseData) dispatch(receiveProductBundleReasons({ items: [responseData] }))
                return responseData
            })
            .catch((error) => {
                dispatch(handleRequestError(error))
                return Promise.reject(error)
            })

const deleteProductBundleReason =
    ({ id: reasonId }) =>
    (dispatch) =>
        axios
            .delete(`/productbundlereason/${reasonId}`)
            .then(() => {
                dispatch(removeProductBundleReason({ id: reasonId }))
            })
            .catch((error) => {
                dispatch(handleRequestError(error))
                return Promise.reject(error)
            })

const receiveProductBundleReasons = (data) => ({ type: RECEIVE_PRODUCT_BUNDLE_REASONS, data })

const removeProductBundleReason = ({ id }) => ({ type: REMOVE_PRODUCT_BUNDLE_REASON, data: { id } })
